export default {
  // Get token from local storage
  getToken() {
    return localStorage.getItem("token");
  },

  // Save given token in local storage
  saveToken(token) {
    localStorage.setItem("token", token);
  },

  // Remove token key
  removeToken() {
    localStorage.removeItem("token");
  }
};
